import { render, staticRenderFns } from "./AppSection.vue?vue&type=template&id=2b54f358&"
import script from "./AppSection.vue?vue&type=script&lang=js&"
export * from "./AppSection.vue?vue&type=script&lang=js&"
import style0 from "./AppSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports